import Navigation from "../../components/Navigation/Navigation";
import FrontendFooter from "../../components/Layout/FrontendFooter";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <div className="app-container">
      <Navigation />

      <section className="inner-banner text-white">
        <div className="home-container">
          <h1 className="page-title">Privacy Policy</h1>
          <p>Your privacy matters to us</p>
        </div>
      </section>

      <section className="home-about">
        <Container maxWidth="lg">
          <Box sx={{ py: 6 }}>
            <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: "7px", backgroundColor: "white" }}>
              <Typography variant="h4" gutterBottom sx={{ color: "#2c89e9", mb: 2, textAlign: "center" }}>
              Privacy Policy for SteelBuddy
              </Typography> 
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                
Welcome to SteelBuddy, a B2B steel buying app that connects steel dealers with retailers and builders. Your privacy is important to us, and this Privacy Policy outlines the types of information we collect, how we use it, and the measures we take to protect it.

              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                1. Information We Collect
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                <strong>Personal Information:</strong>We collect personal information such as names, phone numbers, and email addresses of buyers and sellers to facilitate communication and transactions on our platform.
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                <strong>Product Listings:</strong>We collect information related to the steel products listed on our app, including descriptions, specifications, and pricing.
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                <strong>Usage Data:</strong>We collect data on how users interact with our app, including app usage patterns and preferences, to improve our services.

              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                2. How We Use Your Information:
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                <strong>To Facilitate Transactions:</strong>We use your information to connect buyers and sellers, enable communication, and manage product listings.
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                <strong>To Improve Our App:</strong>We use usage data to analyze how our app is used and to make improvements for a better user experience.

              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                <strong>To Communicate with You:</strong>We may use your contact information to send updates, respond to inquiries, or provide customer support.


              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                3.How We Protect Your Information:
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
              We implement appropriate security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </Typography>
              
              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                4. Sharing Your Information:
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
              We do not sell, trade, or rent your personal information to others.
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                5. Changes to This Privacy Policy:
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
              </Typography>
             
              <Divider sx={{ my: 3 }} />

              <Typography variant="h5" gutterBottom sx={{ color: "#2c89e9", mb: 2 }}>
                6. Contact Us:

              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, mb: 3 }}>
                If you have any questions about this Privacy Policy, please contact us at{' '}
                <a
                  href="mailto:steelbuddy.dev@gmail.com"
                  style={{ color: "#2c89e9", textDecoration: "underline" }}
                >
                  steelbuddy.dev@gmail.com
                </a>.
              </Typography>
              <Divider sx={{ my: 3 }} />
              <Typography variant="body2" sx={{ color: "#666", fontStyle: "italic" }}>
                By using our services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
              </Typography>
            </Paper>
          </Box>
        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default PrivacyPolicy;
